module.exports = __webpack_public_path__ + "static/o_nama_2018-7820ce4c69464288b9a87d186d37cf4e.png";